import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ManagersServiceProvider } from '../../api/managers'

const ManagersService = ManagersServiceProvider()
const name = 'getManagersList'

export default () => (asyncAction(
  name,
  ManagersService.getManagersList
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/manager/getManagersList.js